import { COLLAGE_LAYOUT_STYLES } from '@mixtiles/web-backend-shared'

type CollagesPortfolio = {
  id: string
  allowMissingPhotos: boolean
  styles: COLLAGE_LAYOUT_STYLES[]
}

export function getPortfolioVariant(): CollagesPortfolio {
  return {
    id: 'v3_2023_11',
    allowMissingPhotos: true,
    styles: [
      COLLAGE_LAYOUT_STYLES.CENTERED,
      COLLAGE_LAYOUT_STYLES.GRID,
      COLLAGE_LAYOUT_STYLES.NOTES,
      COLLAGE_LAYOUT_STYLES.HEART,
    ],
  }
}
